<template>
  <div class="million-read-book-list-explore-item"
       @click="handleToBookListDetail(item.id)"
  >
    <ym-img class="cover"
            :src="item.cover"
    />
    <div class="right">
      <div class="top">
        <div class="title ym-line-ellipsis">{{ item.title }}</div>
        <div class="recommend">
          <ym-avatar class="avatar"
                     :avatar="item.recommend.avatar"
          />
          <span class="ym-line-ellipsis">{{ item.recommend.desc }}</span>
        </div>
      </div>
      <div v-if="item.tag"
           class="bottom"
      >
        {{ item.tag }}
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'MillionReadBookListExploreItem',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      handleToBookListDetail(id) {
        this.$router.push({ name: 'MillionReadBookListDetail', params: { id } });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-book-list-explore-item {
    width: 686px;
    padding: 40px;
    margin-bottom: 40px;
    display: flex;
    background: @color-white;
    box-sizing: border-box;
    border-radius: 16px;
    .cover {
      width: 180px;
      height: 182px;
      flex-shrink: 0;
      margin-right: 50px;
    }
    .right {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        .title {
          color: @color-text-base;
          font-size: @font-size-large;
          font-weight: @font-weight-bold;
          line-height: 1;
          margin: 17px 0;
        }
        .recommend {
          display: flex;
          align-items: center;
          .avatar {
            width: 40px;
            height: 40px;
            margin-right: 8px;
          }
          span {
            color: @color-text-light;
            font-size: 26px;
          }
        }
      }
      .bottom {
        align-self: baseline;
        display: inline-block;
        line-height: 40px;
        height: 40px;
        border-radius: 4px;
        background: #fff8de;
        color: #ff8500;
        font-size: @font-size-small;
        padding: 0 8px;
      }
    }
  }

</style>
